import { FormCreator, FormCreatorProps } from "@/components/shared/form-creator";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Service } from "@/models/services.model";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

interface AddServiceModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSubmit: (values: Partial<Service>) => Promise<void>;
}

const formSchema = z.object({
  name: z.string().min(1, "Name is required"),
});

type FormValues = z.infer<typeof formSchema>;

export default function AddServiceModal({ open, setOpen, onSubmit }: AddServiceModalProps) {
  const [loading, setLoading] = useState(false);
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
    },
  });

  const props: FormCreatorProps = {
    form,
    onSubmit: async (values: FormValues) => {
      setLoading(true);
      try {
        onSubmit(values);
        form.reset();
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    },
    formDefinition: [{ type: "text", name: "name", label: "Service Name", required: true }],
    buttonText: loading ? "Creating..." : "Create Service",
    resetButtonText: "Reset",
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <form>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add Service</DialogTitle>
          </DialogHeader>

          <FormCreator {...props} />
        </DialogContent>
      </form>
    </Dialog>
  );
}
